import React from 'react';

/**
 * 顶部标签切换
 */
export default function RescuePushTabs({ activeTab, setActiveTab }) {
  const btn = (id, label, extraStyle = {}) => (
    <button
      onClick={() => setActiveTab(id)}
      style={{
        marginRight: 10,
        padding: '8px 18px',
        background: activeTab === id ? '#1976d2' : '#f5f5f5',
        color: activeTab === id ? '#fff' : '#333',
        border: '1px solid #ddd',
        borderRadius: 4,
        ...extraStyle
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ marginBottom: 24 }}>
      {btn('target', '目标推送')}
      {btn('track', '轨迹推送')}
      {btn('bind', '绑定与选点')}
      {btn('history', '历史管理', { marginRight: 0 })}
    </div>
  );
}
